export default {
  link: {
    height: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    transition: 'all 0.2s linear',
    margin: ({ margin }) => margin
  },
  text: {
    alignItems: 'baseline'
  }
}
